function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 903 copy",
    d: "M9.23-.07v63.94l45.67-32L9.23-.07z",
    style: {
      isolation: "isolate"
    },
    fill: "#010101",
    fillRule: "evenodd"
  }));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYjFlZWFkNDItZGEwZS00MjUwLTg4MDUtMjNhMDYzM2M0M2M5IiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDY0IDY0Ij48ZGVmcz48c3R5bGU+LmIxMjgzMzU5LWFkNDQtNGQxYi1iMzg4LTEyMjU4NjY3NmUzZntmaWxsOiMwMTAxMDE7ZmlsbC1ydWxlOmV2ZW5vZGQ7aXNvbGF0aW9uOmlzb2xhdGU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5hcnJvdy1yaWdodDwvdGl0bGU+PHBhdGggaWQ9ImVlOTRmOTYxLTViZmMtNDFjMy05NWNkLTk1NTY0YjgyYzFmMSIgZGF0YS1uYW1lPSJTaGFwZSA5MDMgY29weSIgY2xhc3M9ImIxMjgzMzU5LWFkNDQtNGQxYi1iMzg4LTEyMjU4NjY3NmUzZiIgZD0iTTkuMjMtLjA3VjYzLjg3bDQ1LjY3LTMyTDkuMjMtLjA3WiIvPjwvc3ZnPg==";
export { SvgArrowRight as ReactComponent };